import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';

import Header from '@/components/Header';
import Footer from '@/components/Footer';
import FloatingDonate from '@/components/FloatingDonate';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Contact from '@/pages/Contact';

function App() {
  return (
    <div className="App min-h-screen bg-vinyl text-cream grain-overlay">
      <BrowserRouter>
        <Header />
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <FloatingDonate />
      </BrowserRouter>
    </div>
  );
}

export default App;
